/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import { overlayStyle } from "./overlay.css";

export function Overlay({ onClick = () => {} }) {
  return (
    <div className={overlayStyle} data-testid="overlay" onClick={onClick} />
  );
}
